import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHierarchy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "Apartment",
			clipPath: "url(#clip0_110213_180)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M33.9101 23.1429H29.7315V17.0357C29.7315 16.8589 29.5869 16.7143 29.4101 16.7143H19.4458V12.8571H23.7851C24.1387 12.8571 24.4279 12.5679 24.4279 12.2143V0.642857C24.4279 0.289286 24.1387 0 23.7851 0H12.2137C11.8601 0 11.5708 0.289286 11.5708 0.642857V12.2143C11.5708 12.5679 11.8601 12.8571 12.2137 12.8571H16.5529V16.7143H6.58866C6.41187 16.7143 6.26723 16.8589 6.26723 17.0357V23.1429H2.08866C1.73509 23.1429 1.4458 23.4321 1.4458 23.7857V35.3571C1.4458 35.7107 1.73509 36 2.08866 36H13.6601C14.0137 36 14.3029 35.7107 14.3029 35.3571V23.7857C14.3029 23.4321 14.0137 23.1429 13.6601 23.1429H9.16009V19.6071H26.8387V23.1429H22.3387C21.9851 23.1429 21.6958 23.4321 21.6958 23.7857V35.3571C21.6958 35.7107 21.9851 36 22.3387 36H33.9101C34.2637 36 34.5529 35.7107 34.5529 35.3571V23.7857C34.5529 23.4321 34.2637 23.1429 33.9101 23.1429ZM11.2494 26.1964V32.9464H4.49937V26.1964H11.2494ZM14.6244 9.80357V3.05357H21.3744V9.80357H14.6244ZM31.4994 32.9464H24.7494V26.1964H31.4994V32.9464Z",
				fill: "black",
				fillOpacity: .85
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_110213_180",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "currentColor"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHierarchy);
export { ForwardRef as ReactComponent };
